import { FormFieldConfig } from "@/types/AppTypes";

// Field configurations
export const loginFormFields: FormFieldConfig[] = [
  {
    name: "email",
    label: "Email",

    type: "email",
    required: true,
  },
  {
    name: "password",
    label: "Password",

    type: "password",
    required: true,
  },
];

export const distributorRegistrationFormFields: FormFieldConfig[] = [
  { name: "firstName", label: "First Name", type: "text", colSpan: true, required: true },
  { name: "lastName", label: "Last Name", type: "text", colSpan: true, required: true },
  { name: "email", label: "Email", type: "email", required: true },
  {
    name: "password",
    label: "Password",

    type: "password",
    required: true,
  },
  {
    name: "confirmPassword",
    label: "Confirm Password",

    type: "password",
    required: true,
  },
];

export const stylistRegistrationFormFields: FormFieldConfig[] = [
  { name: "firstName", label: "First Name", type: "text", colSpan: true, required: true },
  { name: "lastName", label: "Last Name", type: "text", colSpan: true, required: true },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "salonName", label: "Salon Name", type: "text", required: false },
  { name: "password", label: "Password", type: "password", required: true },
  { name: "confirmPassword", label: "Confirm Password", type: "password", required: true },
  { name: "license", label: "License", type: "file", required: true },
];

// export const sellerRegistrationFormFields: FormFieldConfig[] = [
//   { name: "businessName", label: "Business Name", type: "text" , required: true , placeholder: "Your business Name",

//     icon: <Building className="w-5 h-5" />,
//     iconPosition: "left",
//   },
//   {
//     name:"businessDescription",
//     label: "Business Description",
//     type: "textarea",
//     placeholder: "Tell us about your business and what you sell...",
//     required: true,
//   },{
//     name:"businessPhone",
//     label: "Business Phone",
//     type: "tel",
//     placeholder: "(555) 123-4567 ",
//     required: true,
//     icon: <Phone className="w-5 h-5" />,
//     iconPosition: "left",
//   },{
//     name:"address",
//     label: "Address",
//     type: "text",
//     placeholder: "123 Main St",
//     required: true,
//     colSpan: true,
//     icon: <LocateIcon className="w-5 h-5" />,
//     iconPosition: "left",
//   },{
//     name: "city",
//     label: "City",
//     type: "text",
//     placeholder: "City",
//     required: true,
//     colSpan: true,
//   },{
//     name: "state",
//     label: "State",
//     type: "text",
//     placeholder: "State",
//     required: true,
//     colSpan: true,
//   },{
//     name: "zipCode",
//     label: "Zip Code",
//     type: "text",
//     placeholder: "Zip Code",
//     required: true,
//     colSpan: true,
//   },

// ]
